// extracted by mini-css-extract-plugin
export default {"tab":"dOVI3","tabActive":"ToDNU","text":"PKBB6","tabDisabled":"oTgkK"};